var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating-view"},[_c('span',{staticClass:"stars",style:({
      '--rating': _vm.rate,
      '--size': _vm.size,
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }